<template>
  <div>
    <div
      class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3"
    >
      <h3 class="mb-0">{{ title }}</h3>
      <div class="d-flex align-items-center gap-2">
        <slot name="actions" />
        <button
          type="button"
          class="btn btn-primary"
          data-testid="send-offer-btn"
          :disabled="!canSubmit"
          :title="blockingReason ?? undefined"
          @click="$emit('submit')"
        >
          <span
            v-if="isSubmitting"
            class="spinner-border spinner-border-sm me-2"
            role="status"
          ></span>
          {{ $t("soldera_inventory.create_purchase") }}
        </button>
      </div>
    </div>
    <div
      v-if="blockingReason && showBlockingReason"
      class="alert alert-danger py-2"
      data-testid="blocking-reason"
    >
      {{ blockingReason }}
    </div>
    <div v-if="sent" class="alert alert-success py-2" data-testid="offer-sent">
      {{
        $t("soldera_inventory.created_description", { mwh: sent.volume_mwh })
      }}
      <a
        v-if="sent.spreadsheet_link"
        :href="sent.spreadsheet_link"
        target="_blank"
        rel="noopener noreferrer"
        class="ms-1"
        data-testid="offer-sheet-link"
      >
        {{ $t("soldera_inventory.open_breakdown") }}
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { OfferResponse } from "../solderaInventoryTypes";

/**
 * The send row of an offer page, the same on Spot and Forward: the page's title, its own extra
 * actions (slot), the send button, why sending is blocked, and the confirmation of the last offer.
 */
defineProps<{
  title: string;
  canSubmit: boolean;
  isSubmitting: boolean;
  blockingReason: string | null;
  /** Blocking reasons are only worth showing once there is a selection to send. */
  showBlockingReason: boolean;
  /** The offer just sent; null until one is. */
  sent: OfferResponse | null;
}>();

defineEmits<{ submit: [] }>();
</script>
